import React from 'react';
import classnames from 'classnames';
import BaseInputErrors from './BaseInputErrors';
import { SwitchLayoutProps, SwitchLayoutType } from 'framework/form';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputTooltip from './InputTooltip';

const SwitchLayout: SwitchLayoutType = ({
  label = '',
  value,
  errorMessageMapper,
  onChangeCallback,
  onFocusCallback,
  source,
  isRequired = false,
  disabled = false,
  errorMessages = [],
  fullWidth = true,
  className,
  tooltip = null,
  disableLabelClick = false,
  sxSwitch,
}: SwitchLayoutProps) => {
  const hasError = !!errorMessages && errorMessages.length > 0;
  const labelClickStyle = disableLabelClick ? 'none' : 'auto';

  return (
    <FormControl
      className={classnames('form-group switch-form-group', className)}
      fullWidth={fullWidth}
      error={hasError}
      required={!!isRequired}
      variant="standard"
    >
      <FormControlLabel
        sx={{
          '&.MuiFormControlLabel-root:active': {
            pointerEvents: labelClickStyle,
          },
        }}
        disabled={disabled || false}
        value={String(value)}
        control={
          <Switch
            checked={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              if (onChangeCallback) {
                onChangeCallback({
                  [source]: (event.target as HTMLInputElement).checked,
                });
              }
            }}
            onFocus={onFocusCallback}
            name={source}
            sx={{
              ...sxSwitch,
              pointerEvents: 'auto',
            }}
          />
        }
        label={
          <>
            {label}
            {isRequired && <span> *</span>}
            {tooltip && <InputTooltip message={tooltip} source={source} />}
          </>
        }
      />
      <FormHelperText>
        {hasError ? <BaseInputErrors errorMessages={errorMessages} errorMessageMapper={errorMessageMapper} /> : null}
      </FormHelperText>
    </FormControl>
  );
};

export default SwitchLayout;
